import { BaseResponse } from "./BaseResponse.mode";

export class SimpleResponse extends BaseResponse{

}